import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import DialogComponent from '../dialog/dialog.component';
import { createAmount, fetchBalance } from '../../api';
import payment from '../../images/profile/payment.png';
import { InputWarning } from '../inputwarning/input-warning.component';
import ContactSupport from '../../pages/user-setting/tabs/contact-support';
import { useSelector } from 'react-redux';
import { RootState } from '../../configuration';

interface IDialogRequest {
  onConfirm?: () => void;
  onCancel?: () => void;
  isOpen: boolean;
  handleSetOpen: (value: boolean) => void;
}

const DialogRequest = (props: IDialogRequest) => {
  const { onConfirm, onCancel, isOpen, handleSetOpen } = props;
  const profile = useSelector(
    (state: RootState) => state.features.auth.profile
  );
  const handleClose = () => {
    handleSetOpen(false);
  };

  return (
    <DialogComponent
      onClose={() => handleClose()}
      visible={isOpen}
      placement="CENTER"
      title="Yêu cầu xác minh cho Content Creator"
      size="full"
    >
      <div className="flex flex-col">
        {!profile?.isRequestCreator ? (
          <ContactSupport />
        ) : (
          <div className="text-xl text-green-600 p-6 w-full max-w-[976px]">
            Bạn đã gửi yêu cầu xác minh, vui lòng chờ xác minh tài khoản.
          </div>
        )}
      </div>
    </DialogComponent>
  );
};

export default DialogRequest;
